import { FaTimes } from "react-icons/fa";

const typeStyles = {
  success: "bg-green-100 border-green-500 text-green-800",
  error: "bg-red-100 border-red-500 text-red-800",
  warning: "bg-yellow-100 border-yellow-500 text-yellow-800",
  info: "bg-blue-100 border-blue-500 text-blue-800",
};

export default function Alert({ type = "info", title, message, onClose }) {
  return (
    <div className={`w-full p-4 border-l-4 rounded-lg shadow relative ${typeStyles[type]}`}>
      <button
        className="absolute top-2 right-2 text-lg"
        onClick={onClose}
        aria-label="Chiudi alert"
      >
        <FaTimes />
      </button>
      <h3 className="text-base font-semibold">{title}</h3>
      <p className="mt-2 text-sm">{message}</p>
    </div>
  );
}
